export default __webpack_public_path__ + "img/partnership6-6ee8879323f9f6baa4cb783d5a978a0f.png";